import React from 'react';
import styled from 'styled-components';
import { NavigationDrawer } from '~admin/view/components/core/navigation-drawer.component';
import { ToolRouter } from '~admin/view/components/core/tool-router.component';
import { Box } from '~common/components/box.component';
import { Column } from '~common/components/column.component';

export const ToolContainer: React.FunctionComponent = () => {
  return (
    <Container>
      <NavigationDrawer />
      <Content>
        <ToolRouter />
      </Content>
    </Container>
  );
};

const Container = styled(Box)`
  width: 100%;
  height: 100%;
  // TODO(Dmitry): Restrict the width until responsiveness added
  min-width: 1024px;
`;

const Content = styled(Column)`
  flex: 1 1 auto;
`;



// WEBPACK FOOTER //
// ./view/components/core/tool-container.component.tsx